/**
 * PreferencesAdapter — Web 구현 (localStorage 폴백, #447 F7 SPA 웹 배포 대응)
 */

import type { PreferencesAdapter } from "./preferences";

export function createPreferencesAdapter(): PreferencesAdapter {
  return {
    async get(key) {
      try {
        return globalThis.localStorage?.getItem(key) ?? null;
      } catch {
        return null;
      }
    },
    async set(key, value) {
      globalThis.localStorage?.setItem(key, value);
    },
    async remove(key) {
      globalThis.localStorage?.removeItem(key);
    },
  };
}
